var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameReviewHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6494 13.5266C37.9507 13.5266 43.8695 18.8475 43.8695 25.4125C43.8695 27.9135 43.0101 30.2345 41.5422 32.1495L48.2895 38.2155L44.8902 41.2715L38.1428 35.2055C36.0131 36.5255 33.4316 37.2975 30.6494 37.2975C23.3481 37.2975 17.4292 31.9765 17.4292 25.4125C17.4292 18.8475 23.3481 13.5266 30.6494 13.5266ZM30.6494 17.8485C26.0031 17.8485 22.2365 21.2345 22.2365 25.4125C22.2365 29.5895 26.0031 32.9756 30.6494 32.9756C35.2956 32.9756 39.0622 29.5895 39.0622 25.4125C39.0622 21.2345 35.2956 17.8485 30.6494 17.8485ZM15.0711 24.3315C15.0409 24.6885 15.0255 25.0485 15.0255 25.4125C15.0255 26.5275 15.1702 27.6135 15.4436 28.6535H0.603516V24.3315H15.0711ZM10.2182 0.560547V22.1705H3.00721V0.560547H10.2182ZM19.8329 9.20453L19.8325 15.2766C17.6996 17.1166 16.1464 19.4955 15.4436 22.1705H12.6219V9.20453H19.8329ZM29.4475 4.88254V11.4066C26.8059 11.5866 24.3479 12.3585 22.2365 13.5735V4.88254H29.4475ZM39.0622 7.04355L39.0623 13.5735C36.9509 12.3585 34.4929 11.5866 31.8513 11.4066L31.8512 7.04355H39.0622Z",
    fill: "#AE8FD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameReviewHome);
export default __webpack_public_path__ + "static/media/Game-review-home.ab5c6e4ca4555112187f21ff7aa3d4a0.svg";
export { ForwardRef as ReactComponent };